exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".general[data-v-ddad2c1e]{max-width:1200px;margin:0 auto}.tpl-table[data-v-ddad2c1e]{border:1px solid #ebebeb;border-bottom:0}.tpl-table .action span[data-v-ddad2c1e]{margin-right:10px;cursor:pointer}.tpl-table .action .span[data-v-ddad2c1e]{margin-right:10px}.pageation[data-v-ddad2c1e]{padding:30px 10px 20px;border-top:0;min-height:85px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ddad2c1e","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/tpl/authorization.vue
// module id = IXO8
// module chunks = 182